$(document).ready(function(){
    $('.otf-select-group-button').each(function(index, element){
        let $wrap = $(element),
            $select = $wrap.find('>select'),
            $button = $wrap.find('>.button');

        let value = $select.val();
        if(value !== ''){
            let id = $wrap.find('option[value="'+value+'"]').data('id');
            if(id){
                $button.attr('href', $button.data('link') + `&post=${id}`);
                $button.show();
            }

        }

    })
});